export default "__VITE_PUBLIC_ASSET__82df8f41__"